import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 课程列表
 * 
*/

export const courseList = () => Http.get(`${baseUrl}/course`)

/**
 * 所有课程
 * 
*/

export const allCourse = () => Http.get(`${baseUrl}/course/all`)